module.exports = __webpack_public_path__ + "static/media/menu-up.3be82ead.svg";